import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import chroma from 'chroma-js';
import ContrastText from './contrast-text.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'contrast-color-text',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as {
    color: chroma.Color
}

_useCssVars(_ctx => ({
  "7dd168a8": (bgColor.value)
}))



const bgColor = ref(chroma(props.color).hex());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "k-color-text",
    style: _normalizeStyle({ background: bgColor.value })
  }, [
    _createVNode(ContrastText, { color: __props.color }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["color"])
  ], 4))
}
}

})